<template>
  <v-row class="pb-4" no-gutters>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <!-- Dialog copy monthly rates -->
    <dialog-copy-monthly-rates
      v-if="dialogCopyMonthlyRates"
      :dialog="dialogCopyMonthlyRates"
      resource="customs"
      :monthyear="month_year_data"
      v-on:dialog-close="onCloseDialogCopyMonthlyRates"
    ></dialog-copy-monthly-rates>

    <v-row no-gutters>
      <v-col>
        <v-toolbar flat height="50px">
          <v-toolbar-title class="primary--text">Customs Charges</v-toolbar-title>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small icon color="primary" @click="onNewItem" class="mx-4">
                <v-icon>mdi-table-plus</v-icon>
              </v-btn>
            </template>
            Add new pricing item
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                icon
                color="primary"
                @click="onOpenDialogCopyMonthlyRates"
              >
                <v-icon size="22">mdi-content-copy</v-icon>
              </v-btn>
            </template>
            Copy monthly rates into a new month
          </v-tooltip>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="my-0"></v-divider>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <span>Port:</span>
        <v-autocomplete
          class="form-control rounded-0"
          solo
          flat
          placeholder="Select port"
          :items="sortedPortList"
          item-text="label"
          item-value="un_code"
          clearable
          v-model="filter_port"
        >
          <template v-slot:item="data">
            <v-list-item-content style="font-size: 90%">
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:item="data">
            <img :src="CONSTANT.getFlag(data.item.code_country)" class="country-flag" />
            <v-list-item-content style="font-size: 90%">
              <v-list-item-title v-html="data.item.label"></v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <!-- <v-col cols="12" sm="3" md="2">
        <span>Transaction Type:</span>
        <v-select
          class="form-control"
          :items="transactionTypes"
          solo
          flat
          v-model="filter_ttype"
        ></v-select>
      </v-col>-->

      <v-col class="mt-4">
        <div
          class="custom-control custom-checkbox"
          style="height: 36px; padding-top: 10px; display: inline-block"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            id="filterShowTrash"
            v-model="filter_show_trash"
          />
          <label
            class="custom-control-label"
            for="filterShowTrash"
            style="padding-top: 1px"
            >Show trashed</label
          >
        </div>
      </v-col>

      <v-col cols="12" sm="3" md="2" class="pt-10">
        <v-btn
          small
          color="primary"
          class="font-weight-bold"
          tile
          @click="loadPricingTable"
          >SEARCH</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="my-0"></v-divider>
    </v-row>

    <v-row no-gutters justify="center" class="mt-2 mb-1">
      <v-col cols="2">
        <input
          class="form-control rounded-0"
          v-model="searchTable"
          placeholder="Search code"
        />
      </v-col>
    </v-row>

    <v-row dense class="px-1">
      <v-col>
        <v-expansion-panels tile hover v-model="panel" multiple style="border: none">
          <v-expansion-panel
            v-for="(itemData, key) in groupedTableData"
            :key="key"
            class="mb-4"
          >
            <v-expansion-panel-header
              class="title dialog-header-title rounded-0"
              style="min-height: 30px; height: 40px"
            >
              <template v-slot:actions>
                <v-icon color="white">$expand</v-icon>
              </template>
              {{ tableData.length == 0 ? "" : filter_port }}
              {{ key == "export" ? "Export" : "Import" }}
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-2">
              <v-row no-gutters>
                <v-col>
                  <v-card tile color="white">
                    <v-data-table
                      :search="searchTable"
                      :headers="monthsHeaders"
                      :items="itemData"
                      :items-per-page="10"
                      no-data-text="No Monthly Rates"
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="(item, ind) in items" :key="ind">
                            <td style="width: 210px">
                              <v-row no-gutters class="fill-height pl-1 pt-1">
                                <v-col>
                                  <v-row>
                                    <span
                                      style="font-size: 12px"
                                      class="font-weight-bold mr-3"
                                      >{{ item.code }}</span
                                    >

                                    <v-tooltip right>
                                      <template v-slot:activator="{ on }">
                                        <span
                                          v-on="on"
                                          class="d-inline-block text-truncate"
                                          style="max-width: 120px; font-size: 11px"
                                          >{{ item.description }}</span
                                        >
                                      </template>
                                      {{ item.description }}
                                    </v-tooltip>
                                  </v-row>

                                  <v-row class="pt-2" justify="start">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-chip
                                          v-on="on"
                                          x-small
                                          label
                                          :color="
                                            item.container_load == 'FCL'
                                              ? 'light-blue'
                                              : item.container_load == 'LCL'
                                              ? 'blue darken-4'
                                              : 'black'
                                          "
                                          outlined
                                          class="font-weight-bold px-1 mr-1 chip-x-small-custom-1"
                                        >
                                          {{
                                            item.container_load == "*"
                                              ? "ALL"
                                              : item.container_load
                                          }}
                                        </v-chip>
                                      </template>
                                      Container Load
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-chip
                                          v-on="on"
                                          v-show="item.is_domestic"
                                          x-small
                                          label
                                          color="primary"
                                          dark
                                          class="font-weight-bold px-1 mx-1 chip-x-small-custom-2"
                                          >D</v-chip
                                        >
                                      </template>
                                      Is Domestic
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-chip
                                          v-on="on"
                                          v-show="item.is_international"
                                          x-small
                                          label
                                          color="teal"
                                          dark
                                          class="font-weight-bold px-1 mx-1 chip-x-small-custom-2"
                                          >I</v-chip
                                        >
                                      </template>
                                      Is International
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          v-on="on"
                                          x-small
                                          icon
                                          class="pb-2 mx-1"
                                          color="primary"
                                          @click="onUpdateItem(item)"
                                        >
                                          <v-icon size="20">mdi-pencil</v-icon>
                                        </v-btn>
                                      </template>
                                      Edit port information
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn
                                          v-on="on"
                                          x-small
                                          icon
                                          class="pb-2 mx-1"
                                          :color="item.trash ? 'error' : 'grey'"
                                          @click="trashUntrashPPItem(item)"
                                        >
                                          <v-icon size="20">mdi-delete</v-icon>
                                        </v-btn>
                                      </template>
                                      {{ item.trash ? "Untrash item" : "Trash item" }}
                                    </v-tooltip>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </td>
                            <template v-if="!item.rates.length">
                              <td colspan="12"></td>
                            </template>

                            <template v-else>
                              <template v-for="(rate, rkey) in item.rates">
                                <td
                                  :key="rkey"
                                  class="custom-table-tr"
                                  :style="
                                    rkey == 3
                                      ? 'background-color:#B2DFDB'
                                      : 'background-color:#FFFFFF'
                                  "
                                >
                                  <v-row
                                    class="fill-height"
                                    style="cursor: pointer"
                                    @click="onUpdateRate(item, rate)"
                                  >
                                    <pt-rates-cell :rates="rate"></pt-rates-cell>
                                  </v-row>
                                </td>
                              </template>
                            </template>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogUpdateItem" persistent max-width="800px">
      <v-row no-gutters>
        <v-col>
          <v-card color="white" v-if="pt_obj != null" flat tile>
            <v-card-title class="dialog-header-title">{{
              updateTitleItemDialog
            }}</v-card-title>
            <v-card-text class="mt-0 pt-0">
              <v-row no-gutters>
                <v-col>
                  <v-row>
                    <v-col cols="12" sm="6" md="8">
                      <span>Port:</span>
                      <v-autocomplete
                        class="form-control rounded-0"
                        solo
                        flat
                        placeholder="Select port"
                        :items="sortedPortList"
                        item-text="label"
                        item-value="un_code"
                        clearable
                        :background-color="pt_obj.pt_id ? 'grey lighten-4' : ''"
                        :disabled="pt_obj.pt_id ? true : false"
                        v-model="pt_obj.port_un_code"
                      >
                        <template v-slot:item="data">
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.label"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <template v-slot:item="data">
                          <img
                            :src="CONSTANT.getFlag(data.item.code_country)"
                            class="country-flag"
                          />
                          <v-list-item-content style="font-size: 90%">
                            <v-list-item-title
                              v-html="data.item.label"
                            ></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col>
                      <span>Transaction type:</span>
                      <v-select
                        class="form-control"
                        :items="inputTransactionType"
                        return-object
                        solo
                        flat
                        :background-color="pt_obj.pt_id ? 'grey lighten-4' : ''"
                        :disabled="pt_obj.pt_id ? true : false"
                        v-model="pt_obj.transaction_type"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <span>Container load:</span>
                      <!-- <v-select
                        class="form-control"
                        :items="inputContainerLoad"
                        return-object
                        solo
                        flat
                        :background-color="pt_obj.pt_id ? 'grey lighten-4' : ''"
                        :disabled="pt_obj.pt_id ? true : false"
                        v-model="pt_obj.container_load"
                      ></v-select> -->
                      <v-select
                        class="form-control"
                        :items="inputContainerLoad"
                        return-object
                        solo
                        flat
                        v-model="pt_obj.container_load"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <span>Code:</span>
                      <input class="form-control" v-model="pt_obj.code" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                      <span>Description:</span>
                      <input class="form-control" v-model="pt_obj.description" />
                    </v-col>

                    <v-row>
                      <v-col cols="2" class="mt-4">
                        <div
                          class="custom-control custom-checkbox"
                          style="height: 36px; padding-top: 10px; display: inline-block"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="isdomestic"
                            v-model="pt_obj.is_domestic"
                          />
                          <label class="custom-control-label" for="isdomestic"
                            >Is domestic</label
                          >
                        </div>
                      </v-col>

                      <v-col cols="2" class="mt-4 px-0">
                        <div
                          class="custom-control custom-checkbox"
                          style="height: 36px; padding-top: 10px; display: inline-block"
                        >
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="isinternational"
                            v-model="pt_obj.is_international"
                          />
                          <label
                            class="custom-control-label"
                            for="isinternational"
                            style="padding-top: 1px"
                            >Is international</label
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mt-0 pt-0"></v-divider>

            <v-card-actions>
              <v-row justify="end" class="mr-4">
                <v-btn
                  small
                  @click="savePPItem"
                  class="font-weight-bold mr-4"
                  color="primary"
                  tile
                  depressed
                  >SAVE</v-btn
                >
                <v-btn
                  small
                  @click="onCloseDialogUpdateItem"
                  class="font-weight-bold"
                  color="error"
                  tile
                  depressed
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>

    <v-dialog v-model="dialogUpdateRate" persistent max-width="750px">
      <v-row no-gutters>
        <v-col>
          <v-card color="white" v-if="pt_rate_obj != null" flat tile>
            <v-card-title class="dialog-header-title">
              {{ updatedTitleRateDialog }}
            </v-card-title>
            <v-card-text class="mt-0 pt-0">
              <v-row no-gutters>
                <v-col>
                  <v-row>
                    <v-col>
                      <span>Transacton Type:</span>
                      <input
                        class="form-control"
                        disabled
                        v-model="pt_rate_obj.transaction_type"
                      />
                    </v-col>
                    <v-col cols="3">
                      <span>UOM:</span>
                      <v-select
                        class="form-control"
                        :items="inputUOM"
                        return-object
                        solo
                        flat
                        v-model="pt_rate_obj.uom"
                      ></v-select>
                    </v-col>

                    <v-col cols="3">
                      <span>Currency:</span>
                      <v-select
                        :items="currencies"
                        solo
                        flat
                        class="form-control"
                        v-model="pt_rate_obj.currency"
                      ></v-select>
                    </v-col>

                    <v-col cols="3">
                      <span>Round-Up Qty:</span>
                      <input
                        type="number"
                        class="form-control"
                        v-model="pt_rate_obj.roundup_qty"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <span>Price:</span>
                      <input class="form-control" v-model="pt_rate_obj.price.price" />
                    </v-col>

                    <v-col>
                      <span>Min. Price:</span>
                      <input class="form-control" v-model="pt_rate_obj.price.min_price" />
                    </v-col>

                    <v-col>
                      <span>Cost:</span>
                      <input class="form-control" v-model="pt_rate_obj.cost.cost" />
                    </v-col>

                    <v-col>
                      <span>Min. Cost:</span>
                      <input class="form-control" v-model="pt_rate_obj.cost.min_cost" />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mt-0 pt-0"></v-divider>

            <v-card-actions>
              <v-row justify="center" no-gutters>
                <v-btn
                  v-if="edit_pr"
                  @click="savePricingTableRate"
                  class="font-weight-bold mr-2"
                  color="primary"
                  tile
                  depressed
                  >SAVE</v-btn
                >
                <v-btn
                  v-else
                  @click="addPricingTableRate"
                  class="font-weight-bold mr-2"
                  color="primary"
                  tile
                  depressed
                  >CREATE</v-btn
                >
                <v-btn
                  @click="dialogUpdateRate = false"
                  dark
                  class="font-weight-bold ml-2"
                  color="error"
                  tile
                  depressed
                  >CLOSE</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
  </v-row>
</template>

<script>
import constant from "@/const";
import PtRatesCell from "@/components/shared/pt/PtRatesCell.vue";
import DialogCopyMonthlyRates from "@/components/admin/dialogs/DialogCopyMonthlyRates";
export default {
  components: {
    PtRatesCell,
    DialogCopyMonthlyRates,
  },
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      CONSTANT: constant,
      filter_port: "MYPKG", // default to Malaysia Port Klang
      filter_ttype: "ALL",
      filter_show_trash: true,

      inputContainerSize: ["20", "40", "45", "*"],
      inputContainerLoad: ["FCL", "LCL", "*"],
      inputTransactionType: ["EXPORT", "IMPORT"],
      inputContainerType: ["DRY", "REEFER", "OT", "*"],
      inputUOM: ["CTR", "SET", "RT", "QTL", "C3KG", "CW", "KG", "*"],

      currencies: [],

      portList: [],
      transactionTypes: ["ALL", "EXPORT", "IMPORT"],

      panel: [0, 1],

      tableData: [],
      searchTable: "",

      month_year_data: null,

      mon_yr_headers: [],

      monthsHeaders: [
        {
          text: null,
          align: "center",
          sortable: true,
          divider: true,
          value: "code",
        },
      ],

      edit_pr: true,

      dialogUpdateItem: false,
      dialogUpdateRate: false,
      selected_pp_item: {},

      dialogCopyMonthlyRates: false,

      updateTitleItemDialog: null,
      updatedTitleRateDialog: null,

      pp_item_sync: {},
      pt_obj: null,
      pt_rate_obj: null,

      selected_rate_sync: {},
    };
  },
  created() {},
  mounted() {
    this.fetch_ports();
    this.fetch_mon_yr_headers();
    this.loadCurrenciesList();
  },
  watch: {},
  methods: {
    /**
     * fetch ports
     */
    async fetch_ports() {
      var resp = await this.$https.get("/api/ports");
      this.portList = resp.data.data || [];
    },

    /**
     * Get currencies list
     */
    async loadCurrenciesList() {
      var resp = await this.$https.get("/api/currencies/list/dropdown");
      this.currencies = resp.data.data || [];
    },

    /**
     * fetch month year header for pricing rates
     */
    async fetch_mon_yr_headers() {
      var resp = await this.$https.get("/api/pts/mon_yr_headers/8");
      this.month_year_data = resp.data.month_year_data;

      this.mon_yr_headers = resp.data.data;
      this.mon_yr_headers.forEach((item) => {
        // set the months header
        this.monthsHeaders.push({
          text: item,
          sortable: false,
          align: "center",
          divider: true,
        });
      });
    },

    /**
     *  open dialog copy monthly rates
     */
    onOpenDialogCopyMonthlyRates() {
      this.dialogCopyMonthlyRates = true;
    },

    /**
     *  close dialog copy monthly rates
     */
    onCloseDialogCopyMonthlyRates(hasChanged) {
      this.dialogCopyMonthlyRates = false;

      if (hasChanged) {
        this.loadPricingTable();
      }
    },

    /**
     * Query and fetch the Pricing Table Data
     */
    async loadPricingTable() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      var api_string = `/api/pts/customs`;

      // port query value
      if (this.filter_port) {
        api_string = `${api_string}?port=${this.filter_port}`;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = "Port is empty";
        this.$root.blockUIshow = false;
        return;
      }

      // trash query value
      if (this.filter_show_trash) {
        api_string = `${api_string}&trash=all`;
      }

      // transaction type query value
      if (this.filter_ttype != "ALL") {
        api_string = `${api_string}&t_type=${this.filter_ttype}`;
      }

      this.$root.blockUImsg = "Loading customs charges price items...";
      this.$root.blockUIshow = true;

      var resp = await this.$https.get(api_string);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.tableData = resp.data.data || [];
      } else {
        this.tableData = [];
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * On add new pp item
     */
    async onNewItem() {
      let resp = await this.$https.get(`/api/pts/customs/init`);
      this.pt_obj = resp.data.data;
      this.updateTitleItemDialog = "Add new customs charges price item";
      this.dialogUpdateItem = true;
    },

    /**
     * On updated pp item
     */
    async onUpdateItem(pp_item) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;
      // clone
      this.pp_item_sync = pp_item;
      let resp = await this.$https.get(`/api/pts/customs/${pp_item.pt_id}`);
      this.pt_obj = resp.data.data;
      this.updateTitleItemDialog = `Update customs charges`;
      this.dialogUpdateItem = true;
      this.$root.blockUIshow = false;
    },

    /**
     * on edit pt rate
     */
    async onUpdateRate(item, rate) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      if (rate.pt_my_id) {
        let resp = await this.$https.get(
          `/api/pts/customs/monthly_rate/${rate.pt_my_id}`
        );

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // clone rate
          this.selected_rate_sync = rate;

          this.pt_rate_obj = resp.data.data;

          this.updatedTitleRateDialog = `Update ${this.pt_rate_obj.pt_group} rate`;
          this.edit_pr = true;
          this.dialogUpdateRate = true;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
      } else {
        // clone rate
        this.selected_rate_sync = rate;

        // let resp = await this.$https.get(`/api/pts/customs/init/rate`)
        let resp = await this.$https.get(
          `/api/pts/customs/monthly_rate/${rate.month_year}/prev_month?pt_id=${item.pt_id}`
        );
        this.pt_rate_obj = resp.data.data;

        // update pt rate obj
        this.pt_rate_obj.month_year = rate.month_year;
        this.pt_rate_obj.month = rate.month;
        this.pt_rate_obj.year = rate.year;
        this.pt_rate_obj.pt_id = item.pt_id;
        this.pt_rate_obj.pt_group = item.pt_group;
        this.pt_rate_obj.transaction_type = item.transaction_type;

        this.updatedTitleRateDialog = `Add ${rate.month_year}+${item.pt_group} rate`;
        this.edit_pr = false;
        this.dialogUpdateRate = true;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Save pp item
     */
    async savePPItem() {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      try {
        // pt_id is null, then add
        if (this.pt_obj.pt_id == null) {
          let resp = await this.$https.post(`/api/pts/customs`, this.pt_obj);
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = resp.data.msg;
            this.dialogUpdateItem = false;
            this.pt_obj = null;
          } else {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
        } else {
          // if pt_id is not null, then update
          let resp = await this.$https.put(
            `/api/pts/customs/${this.pt_obj.pt_id}`,
            this.pt_obj
          );
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = resp.data.msg;
            this.dialogUpdateItem = false;
            // sync the updated rate
            this.pp_item_sync = Object.assign(this.pp_item_sync, this.pt_obj);

            this.pt_obj = null;
          } else {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
        }
      } catch (error) {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = error;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * save pt rate (update existing data)
     */
    async savePricingTableRate() {
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.put(
        `/api/pts/customs/monthly_rate/${this.pt_rate_obj.pt_my_id}`,
        this.pt_rate_obj
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // sync the updated rate
        this.selected_rate_sync = Object.assign(this.selected_rate_sync, resp.data.data);

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
        this.dialogUpdateRate = false;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
      }
    },

    /**
     * add new pt rate
     */
    async addPricingTableRate() {
      this.$root.blockUImsg = "loading...";
      this.$root.blockUIshow = true;

      let resp = await this.$https.post(
        `/api/pts/customs/monthly_rate`,
        this.pt_rate_obj
      );

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // sync the updated rate
        this.selected_rate_sync = Object.assign(this.selected_rate_sync, resp.data.data);

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
        this.dialogUpdateRate = false;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
        this.$root.blockUIshow = false;
      }
    },

    /**
     * Trash and Untrash pp item
     */
    async trashUntrashPPItem(pp_item) {
      this.$root.blockUImsg = "please wait...";
      this.$root.blockUIshow = true;

      // untrash if trash is true
      if (pp_item.trash) {
        let resp = await this.$https.put(`/api/pts/customs/${pp_item.pt_id}/untrash`);

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // set this pp_item trash value to false
          pp_item.trash = false;

          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
        this.$root.blockUIshow = false;
      } else {
        let resp = await this.$https.delete(`/api/pts/customs/${pp_item.pt_id}`);

        if (resp.data.status == constant.RESPONSE_STATUS_OK) {
          // set this pp_item trash value to true
          pp_item.trash = true;

          this.showSnackbar = true;
          this.snackbarColor = "success";
          this.snackbarMsg = resp.data.msg;
        } else {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = resp.data.msg;
        }
        this.$root.blockUIshow = false;
      }
    },

    /**
     * On close the dialog update item
     */
    onCloseDialogUpdateItem() {
      this.dialogUpdateItem = false;
      this.pt_obj = null;
    },
  },
  computed: {
    sortedPortList() {
      return this.portList.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },

    portDictionary() {
      var portDict = {};

      this.sortedPortList.forEach((element) => {
        portDict[element.un_code] = element;
      });

      return portDict;
    },

    groupedTableData() {
      let ret = {
        export: [],
        import: [],
      };
      this.tableData.forEach((item) => {
        if (item.transaction_type == "EXPORT") {
          ret.export.push(item);
        } else {
          ret.import.push(item);
        }
      });
      return ret;
    },
  },
};
</script>

<style scoped>
.v-data-table {
  border: 2px solid #e0e0e0;
}
::v-deep .v-data-table thead tr th {
  text-align: center;
  text-transform: none;
  color: black !important;
  font-weight: bold;
  border: 1px;
  padding: 2px 0.2rem;
  height: 20px !important;
  line-height: 30px;
}

.v-data-table tbody tr {
  text-align: left;
}

.v-data-table tbody tr .custom-table-tr {
  text-align: center;
}

.v-data-table td {
  padding: 0px;
  height: 30px;
  border-right: thin solid rgba(0, 0, 0, 0.12);
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

::v-deep .v-badge__badge {
  border-radius: 10px;
  color: #fff;
  font-size: 11px;
  height: 18px;
  letter-spacing: 0;
  min-width: 18px;
  padding: 3px 5px;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-indent: 0;
  top: auto;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
}

.v-chip.v-size--x-small.chip-x-small-custom {
  font-size: 9px;
  height: 12px;
}

.v-chip.v-size--x-small.chip-x-small-custom-1 {
  font-size: 8.5px;
  height: 11.5px;
  width: 24px;
}
.v-chip.v-size--x-small.chip-x-small-custom-2 {
  font-size: 8.5px;
  height: 11.5px;
  width: 12px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0 0px 10px;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
}
</style>
